<div style="display: flex">
  <mat-form-field>
    <input
      [readonly]="isReadOnly"
      placeholder="Select the Year"
      matInput
      [matDatepicker]="datepicker"
      [formControl]="yearOfPassing"
    />
    <mat-hint>YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker
      touchUi
      #datepicker
      startView="multi-year"
      (yearSelected)="setYear($event, datepicker)"
      panelClass="year-picker"
    >
    </mat-datepicker>
  </mat-form-field>
  <img
    class="img-class"
    src="assets/images/icons/default_icons/icon-close.png"
    alt="icon-close"
    (click)="clearYear()"
  />
</div>
